import ExceptionConfigSection from './ExceptionConfigSection';
import { assistFieldCategories, assistFieldLabels } from '../constants';

const AssistExceptionsSection = (props: any) => (
  <ExceptionConfigSection
    title="Assist Layouts"
    categories={assistFieldCategories}
    fieldLabels={assistFieldLabels}
    {...props}
  />
);

export default AssistExceptionsSection;
